import React, { useState, useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Scrollbars } from 'react-custom-scrollbars';
import { unstable_batchedUpdates as batchedUpdates } from 'react-dom';
import { Row, Col, Form, Input, Select, message, Radio, Drawer, Space, Spin, Tabs, Tag } from 'antd';
import ConfirmationPopup from './ConfirmationPopup'
import AllCancelPopup from './AllCancelPopup'
import DeleteConnectionPopup from './DeleteConnectionPopup';
import UpdateConnectionPopup from './UpdateConnectionPopup';
import {
    getAllCustomGroupByEntity, findAllCustomOptionsByDropdown,
    findAllCustomFieldsByGroupAndEntity,
} from '../../../Api/Services/CustomeUIApiService';
import { AccountsByAccountType } from '../../../Api/Services/AccountApiService';
import { FecthTableNames, IndustryData, getAllUsersData } from '../../../Api/Services/CommonApiService';
import { getTargetRoles, getTargetDepartments, getCompetitors } from '../../../Api/Services/CompanyApiService';
import { FetchAllServiceLines, getServiceLineDetails, createServiceLine, updateServiceLine, deleteServiceLine } from '../../../Api/Services/ServiceLineApiService'
import { AddUser } from '../style';
import { getQueryFieldsByType } from '../../../Api/Services/ViewApiService';
import { convertCurrency, ExchangeCurrency, DateforQueryBuilder } from '../Filters/FilterConditions';
import { BasicFormWrapper, VerticalFormStyleWrap } from '../../styled';
import Heading from '../../../components/heading/heading';
import { Button } from '../../../components/buttons/buttons';
import { CancelIcon, AiIcon, EditIcon } from '../../../components/Icons/Icons';
import QueryBuilderFunction from '../QueryBuilderComp/QueryBuilderFile'
import CommonFormFields from '../CustomizeUi/DynamicFieldGroup';

const { Option } = Select;

const LEAD_SPECIAL_FIELDS = {
    parentServiceLine: ({ edit, serviceData, form, serviceLineId }) => {
        return (<Select style={{ width: '100%' }} disabled={!edit}
            placeholder="Select Service Line"
            showSearch
            allowClear
            optionLabelProp="label"
            onBlur={() => {
                const value = form.getFieldValue("parentServiceLine");
                if (!value) {
                    form.setFieldsValue({ parentServiceLine: "Not Applicable" });
                }
            }}
            filterOption={(input, option) => {
                const usernameElement = option.children.props.children[1].props.children[0];
                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                    const username = String(usernameElement.props.children);
                    return username.toLowerCase().includes(input.toLowerCase());
                }
                return false;
            }
            }>
            {serviceData?.filter(item => item.service_line_id !== serviceLineId)
                .map((option, i) => (
                    <Option value={option.service_line_name} key={i} label={(
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className='Div_flex2'>
                                <div className='share_image' title={option.service_line_name} style={{ cursor: "default" }}>
                                    <span className="image_icon">
                                        {option.service_line_name?.slice(0, 1)?.toUpperCase()}
                                    </span>
                                    <span className='div-ellipsis'>{option.service_line_name}</span>
                                </div>
                            </div>
                        </div>)}>
                        <div className='UserList-dropdown' title={option.service_line_name}>
                            <div>
                                <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.service_line_name?.slice(0, 1)?.toUpperCase()}
                                </span>
                            </div>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.service_line_name}</p>
                                <p style={{ margin: 0, display: "none" }}>0</p>
                            </div>
                        </div>
                    </Option>))
            }
        </Select>
        )
    },
    serviceLineOwner: ({ edit, users }) => {
        return (
            <Select style={{ width: '100%' }} showSearch disabled={!edit}
                placeholder="Select Service Line Owner"
                optionLabelProp="label"
                filterOption={(input, option) => {
                    const usernameElement = option.children.props.children[1].props.children[0];
                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                        const username = String(usernameElement.props.children);
                        return username.toLowerCase().includes(input.toLowerCase());
                    }
                    return false;
                }
                }>
                {users}
            </Select>
            // <UserOwnerDetails record={{
            //     recordbyFName: displayData?.firstName,
            //     recordbyLName: displayData?.lastName,
            //     recordby: displayData?.service_line_owner,
            //     recordbyProfilePic: displayData?.profilePic
            // }} />
        )
    },
};
const DEFAULT_DROPDOWN_FIELDS = ["parentServiceLine", "serviceOwner"];
const DEFAULT_DROPDOWN_FIELDS2 = ["parentServiceLine"];
// const excludedFields = [];
// const excludedType = ["FileUpload", "MultiFileUpload"];
// const DEFAULT_DROPDOWN_DISPLAY_FIELDS = {
//     "title": "titleName",
//     "leadStatusId": "leadStatus",
//     "leadSourceId": "leadSource",
//     "seniorityLevelId": "seniorityLevel",
//     "industry": "industryName",
// };

const Popup = ({ serviceLine, handleNavigation, drawerFrom, GetAll, typeOfAction, serviceLineId, successMessage, typePage }) => {
    const prevValues = useRef({ UrlId: "", FromPage: "" });
    const localData = useSelector((state) => state.localRedux);
    const ENTITY_ID = localData?.allEntity?.find((item) => item.entityKey === 'serviceLines')?.customEntityId
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const defaultCurrency = localData.currency
    const ConvertRate = defaultCurrency?.exchangeRate;
    const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const [form] = Form.useForm();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [confirmPopup, setConfirmPopup] = useState(false)
    const [deleteId, setDeleteId] = useState()
    const [edit1, setEdit1] = useState(false)
    const [display, setDisplay] = useState(false)
    const [displayData, setDisplayData] = useState()
    const [serviceData, setServiceData] = useState([])
    const [accountbyType, setAccountbyType] = useState([])
    const [industryData, setIndustryData] = useState([])
    const [uiReady, setUiReady] = useState(false)
    const [uiLoad, setUiLoad] = useState(false)
    const [edit, setEdit] = useState(false)
    const [queryField, setQueryField] = useState([])
    const [users, setUsers] = useState([])
    const [leadInitial, setLeadInitial] = useState()
    // const [leadInitial1, setLeadInitial1] = useState()
    const [action, setAction] = useState("Globally")
    const [entityTableMap, setEntityTableMap] = useState([])
    const [errorData, setErrorData] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [viewPopupType, setViewPopupType] = useState()
    const [activeKey, setActiveKey] = useState('1')
    const [fileLists, setFileLists] = useState({});
    const [allFieldStructure, setAllFieldStructure] = useState([]);
    const [customGroups, setCustomGroups] = useState([]);
    const [customFields, setCustomFields] = useState();
    // const [arrayDisplayData, setArrayDisplayData] = useState();
    const [optionsMap, setOptionsMap] = useState({});
    const setFileList = (fieldKey, list) =>
        setFileLists(prev => ({ ...prev, [fieldKey]: list }));
    const [group, setGroup] = useState();
    // function formatDate(value, profile) {
    //     if (!value) return "";
    //     const format = profile?.dateFormate && profile?.dateFormate !== "" ? profile?.dateFormate : "YYYY-MM-DD";
    //     return moment(value).format(format);
    // }
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    function arrayToString(val) {
        if (Array.isArray(val) && val.length > 0) {
            return val.join(",");
        }
        return null;  // 👈 return null if empty or not an array
    }
    function splitToArray(value) {
        if (!value) return [];
        return value.split(",").map(v => v.trim());
    }
    function convertDateFromProfile(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(profile?.timeZone);
        const toTimezone = extractTimezoneName(company?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const currentTimeInProfile = moment.tz(fromTimezone).format("HH:mm");
        const dateWithTime = moment.tz(
            `${dateTime} ${currentTimeInProfile}`,
            "YYYY-MM-DD HH:mm",
            fromTimezone
        );
        const converted = dateWithTime.clone().tz(toTimezone);
        const formattedDate = converted.format("YYYY-MM-DD");
        return formattedDate
    }
    function convertDateFromCompany(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const currentTimeInProfile = moment.tz(fromTimezone).format("HH:mm");
        const dateWithTime = moment.tz(
            `${dateTime} ${currentTimeInProfile}`,
            "YYYY-MM-DD HH:mm",
            fromTimezone
        );
        const converted = dateWithTime.clone().tz(toTimezone);
        const formattedDate = converted.format("YYYY-MM-DD");
        return formattedDate
    }
    const noValueConditions = new Set([
        "IS NOT EMPTY", "IS NOT NULL", "IS EMPTY", "IS NULL",
        "today", "tomorrow", "yesterday",
        "this_week", "next_week", "last_week",
        "this_month", "next_month", "last_month",
        "this_financial_year", "next_financial_year", "last_financial_year",
        "this_quarter", "next_quarter", "last_quarter"
    ]);
    async function getAllTableName() {
        try {
            const data = await FecthTableNames()
            setEntityTableMap(data)
        } catch (error) {
            message.error(error);
        }
    }
    async function AccountApi() {
        try {
            const data = await AccountsByAccountType()
            setAccountbyType(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function getTargetRolesData() {
        setDisplay(true)
        let hideMessage;
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await getTargetRoles(companyProfile?.companyId, serviceLineId, "Service", {})
            let cleaned = typeof response === "string" ? response.trim() : JSON.stringify(response);
            cleaned = cleaned.replace(/^\s*```json\s*/i, "").replace(/\s*```$/i, "").trim();
            const parsed = typeof response === "string" ? JSON.parse(cleaned) : response;
            let responseArr = [];
            if (Array.isArray(parsed)) {
                responseArr = parsed;
            } else if (parsed.relevantJobRoles && Array.isArray(parsed.relevantJobRoles)) {
                responseArr = parsed.relevantJobRoles;
            } else {
                const firstArray = Object.values(parsed).find(v => Array.isArray(v));
                if (firstArray) responseArr = firstArray;
            }
            const oldValues = form.getFieldValue("buyerPersons") || [];
            const merged = [...oldValues, ...responseArr];
            const uniqueDepartments = [...new Set(merged)];
            form.setFieldsValue({ buyerPersons: uniqueDepartments });
            hideMessage();
            setDisplay(false)
        } catch (error) {
            setDisplay(false)
            if (hideMessage) hideMessage();
            message.error(error)
        }
    }
    async function getTargetDepartmentsData() {
        setDisplay(true)
        let hideMessage;
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await getTargetDepartments(companyProfile?.companyId, serviceLineId, "Service", {})
            let cleaned = typeof response === "string" ? response : JSON.stringify(response);
            cleaned = cleaned.replace(/^\s*```json\s*/i, "").replace(/\s*```$/i, "").trim();
            const responseArr = JSON.parse(cleaned);
            const oldValues = form.getFieldValue("targetDepartments") || [];
            const merged = [...oldValues, ...responseArr];
            const uniqueDepartments = [...new Set(merged)];
            form.setFieldsValue({ targetDepartments: uniqueDepartments });
            hideMessage();
            setDisplay(false)
        } catch (error) {
            setDisplay(false)
            if (hideMessage) hideMessage();
            message.error(error)
        }
    }
    async function getCompetitorsData() {
        setDisplay(true)
        let hideMessage;
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await getCompetitors(companyProfile?.companyId, serviceLineId, "Service", {})
            let cleaned = typeof response === "string" ? response : JSON.stringify(response);
            cleaned = cleaned.replace(/^\s*```json\s*/i, "").replace(/\s*```$/i, "").trim();
            const responseArr = JSON.parse(cleaned);
            const oldValues = form.getFieldValue("directCompetitors") || [];
            const merged = [...oldValues, ...responseArr];
            const uniqueDepartments = [...new Set(merged)];
            form.setFieldsValue({ directCompetitors: uniqueDepartments });
            hideMessage();
            setDisplay(false)
        } catch (error) {
            setDisplay(false)
            if (hideMessage) hideMessage(); // hide loading if shown
            message.error(error)
        }
    }
    async function IndustryDataApi() {
        try {
            const data = await IndustryData()
            const options = data.map((option, i) => (
                <Option value={option.industryName} key={i}>
                    {option.industryName}
                </Option>));
            setIndustryData(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Service Line").map((option, i) => (
                <Option value={option.userId}
                    label={(
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className='Div_flex2'>
                                <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                    {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                        < img src={option.profilePic} alt="profile" />
                                        :
                                        <span className="image_icon UserIcon">
                                            {option.firstName?.slice(0, 1)?.toUpperCase()}
                                        </span>
                                    }
                                    <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                </div>
                            </div>
                        </div>
                    )}
                    key={i}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName?.slice(0, 1)?.toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        } catch (error) {
            message.error(error)
        }
    }
    async function GetAllServiceLine() {
        try {
            const datas = await FetchAllServiceLines();
            const defaultOption = {
                service_line_id: "00",
                service_line_name: "Not Applicable"
            };
            const data = [defaultOption, ...datas];
            setServiceData(data);
        } catch (error) {
            message.error(error);
        }
    }
    function RequiredValidity(queryItems) {
        const validateItems = (items) => {
            for (let i = 0; i < items.length; i += 1) {
                const item = items[i];
                if (item.type === "condition") {
                    if (!item.field || !item.operator) {
                        return { isValid: false, message: "Incomplete query" };
                    }
                    const conditionValue = item.value;
                    const isEmptyValue =
                        conditionValue === undefined ||
                        conditionValue === null ||
                        conditionValue === "" ||
                        (Array.isArray(conditionValue) && conditionValue.length === 0);
                    if (!noValueConditions.has(item.operator) && isEmptyValue) {
                        return { isValid: false, message: "Incomplete query" };
                    }
                } else if (item.type === "group" && Array.isArray(item.items)) {
                    const result = validateItems(item.items);
                    if (!result.isValid) {
                        return result;
                    }
                }
            }
            return { isValid: true };
        };
        return validateItems(queryItems);
    }
    const convertQueryData = async (data, setTypeing) => {
        const processItems = async (items) => {
            return Promise.all(
                items.map(async (item) => {
                    const simpleOperators = ["=", "!=", "<", ">"]
                    if (item.type === "condition") {
                        if (setTypeing === "Submit") {
                            if (["competition", "contact_person", "followers", "child_case"].includes(item.field)) {
                                item.value = (item.value && item.value.length > 0)
                                    ? item.value.join(',')
                                    : null;
                            }
                            if (item.Key === 'Date') {
                                if (item.field === "created_at" || item.field === "dealCreatedAt" || item.field === "modified_at") {
                                    if (simpleOperators.includes(item.operator)) {
                                        item.value = convertDateFromProfile(item.value, companyProfile, profile)
                                    }
                                }
                            }
                        } else if (setTypeing === "Seting") {
                            if (["competition", "contact_person", "followers", "child_case"].includes(item.field)) {
                                item.value = item.value
                                    ? item.value.split(',').map(user => Number(user))
                                    : [];
                            }
                            if (item.Key === 'Date') {
                                if (item.field === "created_at" || item.field === "dealCreatedAt" || item.field === "modified_at") {
                                    if (simpleOperators.includes(item.operator)) {
                                        item.value = convertDateFromCompany(item.value, profile, companyProfile)
                                    }
                                }
                            }
                        }
                    } else if (item.type === "group" && Array.isArray(item.items)) {
                        item.items = await processItems(item.items);  // Recursively process sub-items
                    }

                    return item;
                })
            );
        };
        return processItems(data);
    };
    const buildQuery = async (tableName, groupData) => {
        const clausePromises = groupData.items.map(async (item, index) => {
            let clause = "";
            if (item.type === "condition") {
                const isDropDownField = item.Key === "Drop Down";
                const isNumericField = item.Key === "Numbers";
                const isDateField = item.Key === "Date";
                const isValidNumber = item.value !== '' && !Number.isNaN(Number(item.value));
                const isDropDownMultiple = item.Key === "Drop Down" && (item.field === "competition" || item.field === "contact_person" || item.field === "followers" || item.field === "child_case");
                if (item.operator === "IS NULL" || item.operator === "IS NOT NULL") {
                    clause = `${tableName}.${item.field} ${item.operator}`;
                }
                else if (isDropDownMultiple && item.operator === "=") {
                    clause = `${tableName}.${item.field} LIKE '%${item.value}%'`;
                }
                else if (isDropDownMultiple && item.operator === "!=") {
                    clause = `${tableName}.${item.field} NOT LIKE '%${item.value}%'`;
                }
                else if (item.operator === "contains") {
                    clause = `${tableName}.${item.field} LIKE '%${item.value}%'`;
                }
                else if (item.operator === "NOT LIKE") {
                    clause = `${tableName}.${item.field} NOT LIKE '%${item.value}%'`;
                }
                else if (item.operator === "starts_with") {
                    clause = `${tableName}.${item.field} LIKE '${item.value}%'`;
                }
                else if (item.operator === "ends_with") {
                    clause = `${tableName}.${item.field} LIKE '%${item.value}'`;
                }
                else if (isDateField) {
                    if (item.field === "created_at" || item.field === "dealCreatedAt" || item.field === "modified_at") {
                        const supportedViews = ["Lead", "Contact", "Account", "Deal", "Task"];
                        const datefrom = ["today", "yesterday"];
                        if (supportedViews.includes("User")) {
                            const DateOperators = ["=", "!=", "<"];
                            if (DateOperators.includes(item.operator)) {
                                clause = `${tableName}.${item.field} ${item.operator} '${item.value}'`;
                            }
                            else if (datefrom.includes(item.operator)) {
                                clause = `${tableName}.${item.field} = {{${item.operator}}}`;
                            }
                            else {
                                clause = `${tableName}.${item.field} BETWEEN {{${item.operator}_start_date}} AND {{${item.operator}_end_date}}`;
                            }
                        } else {
                            const DateOperators = ["=", "!=", "<"];
                            if (DateOperators.includes(item.operator)) {
                                const dates = await DateforQueryBuilder(item.operator, "DatesTime", item.value, companyProfile, profile)
                                clause = `${tableName}.${item.field} BETWEEN '${dates.start}' AND '${dates.end}'`;
                            }
                            // else if (datefrom.includes(item.operator)) {
                            //     clause = `${tableName}.${item.field} = {{${item.operator}}}`;
                            // }
                            else {
                                clause = `${tableName}.${item.field} BETWEEN {{${item.operator}_start_date_time}} AND {{${item.operator}_end_date_time}}`;
                            }
                        }
                    }
                    else {
                        const simpleOperators = ["=", "!=", "<", ">", "today", "yesterday", "tomorrow"];
                        const datefrom = ["today", "yesterday", "tomorrow"];
                        if (simpleOperators.includes(item.operator)) {
                            if (datefrom.includes(item.operator)) {
                                clause = `${tableName}.${item.field} = {{${item.operator}}}`;
                            } else {
                                clause = `${tableName}.${item.field} ${item.operator} '${item.value}'`;
                            }
                        } else {
                            clause = `${tableName}.${item.field} BETWEEN {{${item.operator}_start_date}} AND {{${item.operator}_end_date}}`;
                        }
                    }
                }
                else {
                    clause = `${tableName}.${item.field} ${item.operator} ${(isNumericField || (isDropDownField && isValidNumber))
                        ? item.value
                        : `'${item.value}'`
                        }`;

                }
            } else if (item.type === "group") {
                const inner = await buildQuery(tableName, item);
                const conditionCount = item.items.filter(
                    (child) => child.type === "condition"
                ).length;
                const shouldWrap = conditionCount > 1;
                clause = shouldWrap ? `(${inner})` : inner;
                // clause = `(${inner})`;
            }
            if (index > 0 && item.relationWithPrevious) {
                clause = `${item.relationWithPrevious.toUpperCase()} ${clause}`;
            }
            return clause;
        });
        const parts = await Promise.all(clausePromises);
        return parts.join(" ");
    };
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;
        // if (typeof a !== typeof b) return false;
        if (
            (typeof a === "number" && typeof b === "string") ||
            (typeof a === "string" && typeof b === "number")
        ) {
            return String(a) === String(b);
        }
        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }
        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;
            return keysA.every(key => isEqual(a[key], b[key]));
        }
        return false;
    };
    const getChangedFields = (currentStructure, initialStructure) => {
        return currentStructure.filter((currField) => {
            const initField = initialStructure.find((f) => f.fieldId === currField.fieldId);
            if (!initField) return true;
            const currValue = currField.value;
            const initValue = initField.value;
            return !isEqual(currValue, initValue);
        });
    };
    const isEqual1 = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };
    const getChangedFields1 = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual1(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    const CloseDrawer = () => {
        setEdit(false)
        setEdit1(false)
        setActiveKey('1')
        setCancelConfirmOpen(false)
        const allValues = form.getFieldsValue(true);
        const resetTitles = {};
        Object.keys(allValues).forEach(key => {
            if (key.startsWith("title-")) {
                resetTitles[key] = undefined;
            }
        });
        form.setFieldsValue(resetTitles);
        const formValues = allFieldStructure
            .filter(item => item.fieldType !== "MultiFileUpload" && item.fieldType !== "FileUpload")
            .reduce((acc, item) => {
                acc[item.fieldKey] =
                    item.fieldType === "Multi-Dropdown" ? [] :
                        item.fieldType === "CheckBox" ? false : null;
                return acc;
            }, {});
        form.setFieldsValue(formValues);
        setFileLists({});
        setAction("Globally")
        setGroup()
        setViewPopupType()
        handleNavigation()
        setAllFieldStructure([])
        prevValues.current = { UrlId: "", FromPage: "" };
        setUiReady(false);
    }
    async function setInitialData(value) {
        const commonData = {
            sharedWith: value.shared_with || "Globally",
            query: value?.query,
            queryBuilder: value?.query_builder,
        };
        const adminExtra = {
            targetIndustries: normalizeValue(value?.target_industries),
            keyFeatures: normalizeValue(value?.key_features),
            competitiveAdvantages: normalizeValue(value?.competitive_advantages),
            buyerPersons: normalizeValue(value?.buyer_persons),
            targetDepartments: normalizeValue(value?.target_departments),
            directCompetitors: normalizeValue(value?.direct_competitors),
            specialInstructionsforBots: normalizeValue(value?.special_instructionsfor_bots),
        };
        setLeadInitial({
            ...commonData,
            ...(profile.roleName === "Administrator" ? adminExtra : {})
        });
    }
    const fetchDropdownOptions = async () => {
        const allAttrs = Object.values(customFields || {}).flat();
        const dropdownIds = [...new Set(
            allAttrs
                .filter(attr => attr.dropdownId)
                .map(attr => attr.dropdownId)
        )];
        if (!dropdownIds.length) return;
        const results = await Promise.allSettled(
            dropdownIds.map(id => findAllCustomOptionsByDropdown(id))
        );
        const map = results.reduce((acc, result, index) => {
            const attr = allAttrs.find(a => a.dropdownId === dropdownIds[index]);
            if (result.status === 'fulfilled') {
                acc[dropdownIds[index]] = result.value
                    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
                    .map(item => ({
                        value: item.customDropdownOptionId,
                        label: item.option,
                        optionKey: item.optionKey,
                    }));
            } else {
                acc[dropdownIds[index]] = [];
                message.error(`Failed to load "${attr?.dropdownType}" dropdown`);
            }
            return acc;
        }, {});
        setOptionsMap(map);
    };
    const fetchCustomGroupsAndFields = async () => {
        try {
            const groups = await getAllCustomGroupByEntity(ENTITY_ID);
            const sorted = [...(groups || [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
            const OriginalGruops = sorted.filter((item) => item.value !== "sharedWith")
            const results = await Promise.all(
                OriginalGruops.map(group => findAllCustomFieldsByGroupAndEntity(ENTITY_ID, group.customFieldGroupId))
            );
            const fieldsMap = {};
            OriginalGruops.forEach((group, index) => {
                fieldsMap[group.customFieldGroupId] = [...(results[index] || [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
            });
            const allFields = Object.values(fieldsMap).flat();
            const structure = allFields
                .filter((item) => item?.fieldKey !== "sharedWith")
                .map((field) => ({
                    entityId: field.entityId,
                    fieldId: field.fieldId,
                    fieldKey: field.fieldKey,
                    fieldType: field.fieldType,
                    fieldLabel: field.fieldLabel,
                    customFieldType: field.customFieldType,
                    dropdownId: field.dropdownId,
                    dropdownType: field.dropdownType,
                    value: field.fieldKey === "parentServiceLine" ? "Not Applicable" : field.fieldType === 'MultiFileUpload' ? [] :
                        field.fieldType === "CheckBox" ? false : null,
                }));
            batchedUpdates(() => {
                setCustomGroups(OriginalGruops);
                setCustomFields(fieldsMap);
                setAllFieldStructure(structure);
            });
        } catch {
            message.error("Failed to load custom fields");
        }
    };
    async function preprocessFormValues(value, allFieldStructure) {
        const formattedValue = { ...value };
        formattedValue.customFieldValues = await Promise.all(
            (formattedValue.customFieldValues || []).map(async cf => {
                const fieldDef = allFieldStructure.find(f => f.fieldId === cf.fieldId);
                if (!fieldDef) return cf;
                let newValue;
                switch (fieldDef.fieldType) {
                    case "Multi-Dropdown":
                        newValue = cf.value ? cf.value.split(",").map(id => Number(id)) : [];
                        break;
                    case "Dropdown":
                        newValue = cf.value !== undefined && cf.value !== null ? Number(cf.value) : null;
                        break;
                    case "Number":
                    case "Percentage":
                        newValue = cf.value ? Number(cf.value) : null;
                        break;
                    case "Currency": {
                        const convertedCost = cf.value ? await ExchangeCurrency(Number(cf.value), ConvertRate) : null;
                        newValue = convertedCost ? Number(convertedCost?.toFixed(CurencyDecimalPlace)) : null;
                        break;
                    }
                    case "Date":
                        newValue = cf.value ? moment(cf.value) : null;
                        break;
                    case "CheckBox":
                        newValue = cf.value === "1" || cf.value === 1 || cf.value === true || cf.value === "true";
                        break;
                    default:
                        newValue = cf.value;
                        break;
                }
                return { ...cf, value: newValue };
            })
        );
        await Promise.all(
            allFieldStructure
                .filter(f => f.customFieldType === "Default")
                .map(async item => {
                    let val = formattedValue[item.fieldKey] ?? null;
                    switch (item.fieldType) {
                        case "Multi-Dropdown":
                            val = val ? val.split(",").map(id => Number(id)) : [];
                            break;
                        case 'MultiFileUpload':
                            val = val || [];
                            break;
                        case "Dropdown": {
                            if (DEFAULT_DROPDOWN_FIELDS.includes(item.fieldKey)) {
                                val = normalizeValue(val)
                            } else {
                                val = val !== undefined && val !== null ? Number(val) : null;
                            }
                            break;
                        }
                        case "Number":
                        case "Percentage":
                            val = val !== undefined && val !== null ? Number(val) : null;
                            break;
                        case "Currency": {
                            const convertedCost = val ? await ExchangeCurrency(Number(val), ConvertRate) : null;
                            val = convertedCost ? Number(convertedCost?.toFixed(CurencyDecimalPlace)) : null;
                            break;
                        }
                        case "Date":
                            val = val ? moment(val) : null;
                            break;
                        case "CheckBox":
                            val = val === "1" || val === 1 || val === true || val === "true";
                            break;
                        default:
                            val = normalizeValue(val);
                            break;
                    }
                    if (["mobile", "phone", "postcode"].includes(item.fieldKey)) {
                        val = val === "0" || val === 0 ? null : val;
                    }
                    formattedValue[item.fieldKey] = val;
                })
        );
        return formattedValue;
    }
    async function preprocessFormValues1(value, allFieldStructure) {
        const formattedValue = { ...value };
        formattedValue.customFieldValues = await Promise.all(
            (formattedValue.customFieldValues || []).map(async cf => {
                const fieldDef = allFieldStructure.find(f => f.fieldId === cf.fieldId);
                if (!fieldDef) return cf;
                let newValue;
                switch (fieldDef.fieldType) {
                    case "Dropdown":
                    case "Number":
                    case "Percentage":
                    case "Currency":
                        newValue = cf.value ? Number(cf.value) : null;
                        break;
                    case "Multi-Dropdown":
                    case "Date":
                        newValue = cf.value ? String(cf.value) : null;
                        break;
                    default:
                        newValue = cf.value;
                        break;
                }
                return { ...cf, value: newValue };
            })
        );
        await Promise.all(
            allFieldStructure
                .filter(f => f.customFieldType === "Default")
                .map(async item => {
                    let val = formattedValue[item.fieldKey] ?? null;
                    switch (item.fieldType) {
                        case "Dropdown": {
                            if (DEFAULT_DROPDOWN_FIELDS2.includes(item.fieldKey)) {
                                val = normalizeValue(val)
                            } else {
                                val = val !== undefined && val !== null ? Number(val) : null;
                            }
                            break;
                        }
                         case 'MultiFileUpload':
                            val = val || [];
                            break;
                        case "Number":
                        case "Percentage":
                        case "Currency":
                            val = val ? Number(val) : null;
                            break;
                        case "Multi-Dropdown":
                        case "Date":
                            val = val ? String(val) : null;
                            break;
                        default:
                            val = normalizeValue(val);
                            break;
                    }
                    if (["mobile", "phone", "postcode"].includes(item.fieldKey)) {
                        val = val === "0" || val === 0 ? null : val;
                    }
                    formattedValue[item.fieldKey] = val;
                })
        );
        return formattedValue;
    }
    const setDataTostate = async (value) => {
        if (value) {
            const newStructure = {
                ...value,
                serviceLineName: value?.service_line_name,
                parentServiceLine: value?.parent_service_line || "Not Applicable",
                serviceLineOwner: value?.service_line_owner,
                serviceLinefiles: value?.service_line_files,
                sharedWith: value?.shared_with,
            }
            const adminExtra = {
                targetIndustries: newStructure?.target_industries ? splitToArray(newStructure?.target_industries) : [],
                keyFeatures: newStructure?.key_features,
                competitiveAdvantages: newStructure?.competitive_advantages,
                buyerPersons: newStructure?.buyer_persons ? splitToArray(newStructure?.buyer_persons) : [],
                targetDepartments: newStructure?.target_departments ? splitToArray(newStructure?.target_departments) : [],
                directCompetitors: newStructure?.direct_competitors ? splitToArray(newStructure?.direct_competitors) : [],
                specialInstructionsforBots: newStructure?.special_instructionsfor_bots,
            };
            const formattedValue = await preprocessFormValues(newStructure, allFieldStructure);
            const formattedValue1 = await preprocessFormValues1(newStructure, allFieldStructure);
            const formValues = allFieldStructure.reduce((acc, item) => {
                const fieldKeys = item.fieldKey;
                let fieldValue;

                if (item.customFieldType === "Custom") {
                    const cf = formattedValue?.customFieldValues?.find(cf => cf.fieldId === item.fieldId);
                    fieldValue = cf ? cf.value ?? null : null;
                } else {
                    fieldValue = fieldKeys === "parentServiceLine"
                        ? (formattedValue[fieldKeys] ?? "Not Applicable") : formattedValue[fieldKeys];
                }
                acc[fieldKeys] =
                    item.fieldType === "Multi-Dropdown"
                        ? fieldValue || []
                        : normalizeValue(fieldValue) ?? null;

                return acc;
            }, {});
            const updatedFieldStructure = allFieldStructure.map(item => {
                const fieldKeys = item.fieldKey;
                let fieldValue;
                if (item.customFieldType === "Custom") {
                    const cf = formattedValue1?.customFieldValues?.find(cf => cf.fieldId === item.fieldId);
                    fieldValue = cf ? cf.value ?? null : null;
                } else {
                    fieldValue = fieldKeys === "parentServiceLine"
                        ? (formattedValue1[fieldKeys] ?? "Not Applicable") : formattedValue1[fieldKeys];
                }
                // if (item.fieldType === "Date" && fieldValue) {
                //     fieldValue = moment(fieldValue).format("YYYY-MM-DD");
                // }
                return {
                    ...item,
                    value: fieldValue
                };
            });
            setAllFieldStructure(updatedFieldStructure)
            form.setFieldsValue({
                ...formValues,
                ...(profile.roleName === "Administrator" ?
                    adminExtra : {})
            });
            setFileList('serviceLinefiles', formattedValue.serviceLinefiles || []);
            setAction(newStructure.sharedWith || "Globally")
            if (newStructure.sharedWith === "Specific_user") {
                const copiedGroup = JSON.parse(JSON.stringify(newStructure?.query));
                const processedItems = await convertQueryData(copiedGroup.items, "Seting");
                copiedGroup.items = processedItems;
                setGroup(copiedGroup)
                setViewPopupType("Edit")
            } else {
                setGroup()
                setViewPopupType("Create")
            }
            setDisplayData(newStructure)
        }
    }
    async function getDataApi(value) {
        try {
            const data = await getServiceLineDetails(value);
            setDataTostate(data)
            setInitialData(data)
        } catch (error) {
            message.error(error)
        }
    }
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        setDisplay(true)
        const {
            targetIndustries,
            buyerPersons,
            keyFeatures,
            competitiveAdvantages,
            directCompetitors,
            targetDepartments,
            specialInstructionsforBots
        } = values;
        let hideMessage;
        if (action === "Specific_user") {
            const validation = RequiredValidity(group?.items);
            if (!validation.isValid) {
                message.error(validation.message);
                setDisplay(false)
                return;
            }
        }
        let SaveQuery = "";
        let copiedGroup;
        if (action === "Specific_user") {
            copiedGroup = JSON.parse(JSON.stringify(group));
            const processedItems = await convertQueryData(copiedGroup.items, "Submit");
            copiedGroup.items = processedItems;
            const tableName = entityTableMap.find(t => t.entityName === "Users")?.tableName || "";
            const finalQuery = await buildQuery(tableName, copiedGroup);
            if (tableName) {
                SaveQuery = `SELECT {{*}} FROM ${tableName} WHERE (${finalQuery})`;
            } else {
                SaveQuery = finalQuery;
            }
        }
        const currentStructure = await Promise.all(
            allFieldStructure.map(async (field) => {
                let value;
                switch (field.fieldType) {
                    // case 'FileUpload':
                    //     value = normalizeValue(images[field.fieldKey] ?? null);
                    //     break;
                    case 'MultiFileUpload':
                        value = fileLists[field.fieldKey] || [];
                        break;
                    case 'Date':
                        value = values[field.fieldKey]
                            ? moment(values[field.fieldKey]).format("YYYY-MM-DD")
                            : null;
                        break;
                    case 'Number':
                        // string → number or null
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? Number(values[field.fieldKey])
                            : null;
                        break;
                    case 'Percentage':
                        // string → number or null
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? Number(values[field.fieldKey])
                            : null;
                        break;
                    case 'Currency':
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? await convertCurrency(ConvertRate, Number(values[field.fieldKey]))
                            : null;
                        break;
                    case 'Multi-Dropdown':
                        value = values[field.fieldKey] && values[field.fieldKey].length > 0
                            ? values[field.fieldKey].join(",")
                            : null;
                        break;
                    case 'CheckBox':
                        value = values[field.fieldKey] ?? false;
                        break;
                    default:
                        value = normalizeValue(values[field.fieldKey] ?? null);
                        break;
                }
                return { ...field, value };
            })
        );
        const formData = {
            sharedWith: normalizeValue((profile.roleName === "Administrator" || (profile.companyRole === "Administrator" ||
                profile.companyRole === "CEO")) ? action : "None"),
            query: action === "Specific_user" ? copiedGroup : null,
            queryBuilder: action === "Specific_user" ? SaveQuery : null,
        }
        if (formData.roleName === "Administrator") {
            formData.targetIndustries = normalizeValue(arrayToString(targetIndustries));
            formData.keyFeatures = normalizeValue(keyFeatures);
            formData.competitiveAdvantages = normalizeValue(competitiveAdvantages);
            formData.buyerPersons = normalizeValue(arrayToString(buyerPersons));
            formData.directCompetitors = normalizeValue(arrayToString(directCompetitors));
            formData.targetDepartments = normalizeValue(arrayToString(targetDepartments));
            formData.specialInstructionsforBots = normalizeValue(specialInstructionsforBots);
        }
        const updatedFields = getChangedFields1(formData, leadInitial);
        const changedFields = getChangedFields(currentStructure, allFieldStructure);
        const noDefaultChanges = changedFields.length === 0;
        const noExtraChanges = !updatedFields || Object.keys(updatedFields).length === 0;
        if (noDefaultChanges && noExtraChanges) {
            message.success("Service line updated")
            GetAll()
            setDisplay(false)
            CloseDrawer()
            setEdit(false)
            return;
        }
        const defaultChanges = {};
        const customFieldValues = [];
        changedFields.forEach((field) => {
            if (field.customFieldType === "Default") {
                defaultChanges[field.fieldKey] = field.value;
            } else {
                const obj = {
                    entityId: field.entityId,
                    fieldId: field.fieldId,
                    value: field.value,
                };
                customFieldValues.push(obj);
            }
        });
        const payload = {
            ...defaultChanges,
            ...(customFieldValues.length > 0 && { customFieldValues }),
            ...(updatedFields && Object.keys(updatedFields).length > 0 && updatedFields),
        };
        if (typeOfAction === "Create") {
            try {
                hideMessage = message.loading("Loading...", 0);
                const response = await createServiceLine(payload)
                if (response.status === 201) {
                    GetAll()
                    hideMessage();
                    setDisplay(false)
                    setEdit(false)
                    if (response?.data === AutomationMessage) {
                        successMessage("Automation rule triggered", response?.data)
                    } else {
                        message.success(response?.data)
                    }
                    CloseDrawer()
                    loadingRef.current = false;
                    setDelteClick(false)
                }
            } catch (error) {
                loadingRef.current = false;
                setDelteClick(false)
                setDisplay(false)
                hideMessage();
                message.error(error)
            }
        }
        if (typeOfAction === "Update") {
            try {
                if (payload.queryBuilder && !('sharedWith' in payload)) {
                    payload.sharedWith = normalizeValue((profile.roleName === "Administrator" || (profile.companyRole === "Administrator" ||
                        profile.companyRole === "CEO")) ? action : "None")
                }
                hideMessage = message.loading("Loading...", 0);
                const response = await updateServiceLine(serviceLineId, payload)
                if (response.status === 200) {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                        setConfirmPopup(false)
                        hideMessage();
                        setDisplay(false)
                        loadingRef.current = false;
                        setDelteClick(false)
                    }
                    else {
                        GetAll()
                        hideMessage();
                        setDisplay(false)
                        setEdit(false)
                        if (response.data[0].message === AutomationMessage) {
                            successMessage("Automation rule triggered", response.data[0].message)
                        } else {
                            message.success(
                                <span>
                                    Service Line <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                </span>
                            );
                        }
                        CloseDrawer()
                        loadingRef.current = false;
                        setDelteClick(false)
                    }
                }
            } catch (error) {
                loadingRef.current = false;
                setDelteClick(false)
                setDisplay(false)
                hideMessage();
                message.error(error)
            }
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const handleCheckbox = (value) => {
        setAction(value)
        if (value === "Specific_user") {
            if (!group) {
                setViewPopupType("Create")
            }
        }
    }
    const getQueryFields = async () => {
        try {
            const response = await getQueryFieldsByType("Users", "Views")
            setQueryField(response)
        } catch (error) {
            message.error(error)
        }
    }
    const HandleIsModalVisible = (value) => {
        setIsModalVisible(value)
    }
    async function deleteMenu(id) {
        setDisplay(true)
        try {
            const Response = await deleteServiceLine(id)
            if (Response.status === 200) {
                if (Array.isArray(Response.data) && Response.data.length > 0 && Response.data[0].entityType !== 'Success') {
                    setErrorData(Response.data);
                    setIsModalVisible(true);
                    setDisplay(false)
                    setConfirmPopup(false)
                } else {
                    GetAll()
                    setEdit(false)
                    setConfirmPopup(false)
                    setDisplay(false)
                    if (Response.data[0].entityMessage === AutomationMessage) {
                        successMessage("Automation rule triggered", Response.data[0].entityMessage)
                    } else {
                        message.success(
                            <span>
                                Service line <strong>{Response?.data?.[0]?.entityName}</strong> has been deleted successfully
                            </span>
                        );
                    }
                    CloseDrawer()
                }
            }
        } catch (error) {
            setDisplay(false)
            setConfirmPopup(false)
            message.error(error)
        }
    }
    const OnClickofDelete = (value) => {
        setConfirmPopup(true)
        setDeleteId(value)
    }
    const fetchAll1 = async () => {
        await Promise.allSettled([
            fetchDropdownOptions(),
        ]);
        setTimeout(() => {
            setUiReady(true);
        }, 1000);
    };
    const fetchAll = async () => {
        await Promise.allSettled([
            GetAllServiceLine(),
            UserDetailsApi(),
            getQueryFields(),
            getAllTableName(),
            AccountApi(),
            IndustryDataApi()
        ])
    };
    useEffect(() => {
        if (typeOfAction) {
            fetchCustomGroupsAndFields()
        }
    }, [typeOfAction]);
    useEffect(() => {
        if (typeOfAction && displayData && customFields) {
            fetchAll1();
        }
    }, [typeOfAction, displayData, customFields]);
    useEffect(() => {
        if (typeOfAction && serviceLine && displayData) {
            fetchAll();
        }
    }, [typeOfAction, serviceLine, displayData])
    useEffect(() => {
        if (allFieldStructure.length) {
            const currentUrlId = serviceLineId;
            const currentFromPage = typeOfAction;
            if (prevValues.current.UrlId === currentUrlId && prevValues.current.FromPage === currentFromPage) return;
            prevValues.current = { UrlId: currentUrlId, FromPage: currentFromPage };
            if (typeOfAction === "Create") {
                setDisplayData("create")
                const formValues = allFieldStructure
                    .filter(item => item.fieldType !== "MultiFileUpload" && item.fieldType !== "FileUpload")
                    .reduce((acc, item) => {
                        acc[item.fieldKey] =
                            item.fieldType === "Multi-Dropdown" ? [] :
                                item.fieldType === "CheckBox" ? false :
                                    item.fieldKey === "parentServiceLine" ? "Not Applicable" :
                                        undefined;
                        return acc;
                    }, {});
                form.setFieldsValue(formValues);
                setLeadInitial(profile.roleName === "Administrator" ?
                    {
                        sharedWith: null,
                        query: null,
                        queryBuilder: null,
                        targetIndustries: null,
                        keyFeatures: null,
                        competitiveAdvantages: null,
                        buyerPersons: null,
                        targetDepartments: null,
                        directCompetitors: null,
                        specialInstructionsforBots: null
                    } :
                    {
                        sharedWith: null,
                        query: null,
                        queryBuilder: null,
                    })
                setFileLists({});
                setAction("Globally")
                setGroup()
                setViewPopupType("Create")
                setEdit(true)
            }
            if (typeOfAction === "Update" && serviceLineId) {
                getDataApi(serviceLineId)
            }
        }
    }, [serviceLineId, typeOfAction, allFieldStructure])
    const PageCancel1 = () => {
        if (edit || edit1) {
            setCancelConfirmOpen(true)
        }
        else {
            CloseDrawer()
        }
    }
    const CloseDrawer2 = () => {
        if (activeKey === "1") { setEdit(false) } else { setEdit1(false) }
        getDataApi(serviceLineId)
        const allValues = form.getFieldsValue(true);
        const resetTitles = {};
        Object.keys(allValues).forEach(key => {
            if (key.startsWith("title-")) {
                resetTitles[key] = undefined;
            }
        });
        form.setFieldsValue(resetTitles);
    }
    const PageCancel = () => {
        if (typeOfAction === "Update" && serviceLineId) {
            CloseDrawer2()
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    const getRefreshtheTable = () => {
        GetAll()
        setConfirmPopup(false)
        setDisplay(false)
        setEdit(false)
        CloseDrawer()
    }
    const leadSharedProps = useMemo(() => ({
        form, edit, displayData, serviceData, serviceLineId,
        fileLists, setFileList, users
    }), [
        form, edit, displayData, serviceData, serviceLineId,
        fileLists, setFileList, users
    ]);
    const pageContent1 = (<AddUser>
        <div className="user-info-form">
            <BasicFormWrapper>
                <VerticalFormStyleWrap>
                    <div className="add-product-block">
                        <div style={{ margin: 40 }}>
                            <CommonFormFields
                                groups={customGroups}
                                customFields={customFields || {}}
                                specialFields={LEAD_SPECIAL_FIELDS}
                                sharedProps={leadSharedProps}
                                optionsMap={optionsMap}
                                combinedUrl={undefined}
                                moduleIcon="ServiceLineIcon"
                                moduleLetter={displayData?.service_line_name?.slice(0, 1)?.toUpperCase() || 'S'}
                            />
                            {(profile.roleName === "Administrator" || (profile.companyRole === "Administrator" ||
                                profile.companyRole === "CEO")) ?
                                <>
                                    <Heading as="h5">Shared With</Heading>
                                    <Radio.Group value={action} onChange={(e) => handleCheckbox(e.target.value)} style={{ width: '100%' }} disabled={!edit}>
                                        <Row gutter={30} style={{ margin: "20px 0px 0px" }}>
                                            <Col span={1} style={{ marginBottom: 30 }} />
                                            <Col span={6} style={{ marginBottom: 30 }} ><Radio value='Globally'>Globally</Radio></Col>
                                            <Col span={1} style={{ marginBottom: 30 }} />
                                            <Col span={6} style={{ marginBottom: 30 }} ><Radio value='Specific_user'>Specific Users</Radio></Col>
                                            <Col span={1} style={{ marginBottom: 30 }} />
                                            <Col span={6} style={{ marginBottom: 30 }} ><Radio value='None'>Only me</Radio></Col>
                                        </Row>
                                    </Radio.Group>
                                    {action === "Specific_user" &&
                                        <>
                                            {viewPopupType ?
                                                <div style={{ marginBottom: 30, padding: "0px 15px" }}>
                                                    <QueryBuilderFunction viewType="User" queryField={queryField} group={group} setGroup={setGroup} setUiLoad={setUiLoad} pageFor={viewPopupType === "Create" ? "New" : "Edit"}
                                                        pageFrom="ShareQuery" isEditable={edit} uiLoad={uiLoad} />
                                                </div> : <></>}
                                        </>
                                    }
                                </> : <></>}
                        </div></div>
                </VerticalFormStyleWrap>
            </BasicFormWrapper>
        </div>
    </AddUser >)
    const pageContent2 = (<AddUser>
        <div className="user-info-form">
            <BasicFormWrapper>
                <VerticalFormStyleWrap>
                    <div className="add-product-block">
                        <div style={{ margin: 40 }}>
                            <Heading as="h5">Service Insights</Heading>
                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                <Col span={24} style={{ marginBottom: 30 }}>
                                    <Form.Item label="Target Industries" name="targetIndustries"
                                        id="targetIndustries"
                                        rules={edit1 ? [{ required: true, whitespace: true, message: 'Please select a target industries', }] : [{ required: false }]}
                                    >
                                        {edit1 ? <Select style={{ width: '100%' }}
                                            placeholder="Select target industries" mode="multiple" className='MultiUiNew'>
                                            {industryData}
                                        </Select> :
                                            <div>
                                                {displayData?.target_industries
                                                    ? displayData.target_industries.split(",").map((person, index) => (
                                                        <Tag key={index} color="blue" style={{ marginBottom: 4, marginRight: 4 }}>
                                                            {person}
                                                        </Tag>
                                                    ))
                                                    : "Not Applicable"}
                                            </div>
                                        }
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Row align="middle" gutter={16} style={{ marginBottom: 30 }}>
                                        <Col span={edit1 ? 21 : 24} >
                                            <Form.Item label="Target Departments" name="targetDepartments"
                                                id="targetDepartments"
                                                rules={edit1 ? [{ required: true, whitespace: true, message: 'Please select a target departments', }] : [{ required: false }]}
                                            >
                                                {edit1 ? <Select mode="tags" className='MultiUiNew'
                                                    style={{ width: "100%" }}
                                                    placeholder="Type and press enter"
                                                    tokenSeparators={[","]}
                                                    open={false} /> :
                                                    <div>
                                                        {displayData?.target_departments
                                                            ? displayData.target_departments.split(",").map((person, index) => (
                                                                <Tag key={index} color="blue" style={{ marginBottom: 4, marginRight: 4 }}>
                                                                    {person}
                                                                </Tag>
                                                            ))
                                                            : "Not Applicable"}
                                                    </div>
                                                }
                                            </Form.Item>
                                        </Col>
                                        {edit1 ? <Col span={3} style={{ marginTop: 5 }}>
                                            <Form.Item label=" ">
                                                <Button size="small" className="gradient-button" disabled={display} onClick={() => getTargetDepartmentsData()}>
                                                    <AiIcon /> AI Assist
                                                </Button></Form.Item>
                                        </Col> : <></>}</Row>
                                </Col>
                                <Col span={24}>
                                    <Row align="middle" gutter={16} style={{ marginBottom: 30 }}>
                                        <Col span={edit1 ? 21 : 24} >
                                            <Form.Item label="Buyer Persons / Roles" name="buyerPersons"
                                                id="buyerPersons"
                                                rules={edit1 ? [{ required: true, whitespace: true, message: 'Please enter buyer persons / roles', }] : [{ required: false }]}
                                            >
                                                {edit1 ? <Select
                                                    mode="tags"
                                                    className='MultiUiNew'
                                                    style={{ width: "100%" }}
                                                    placeholder="Type and press enter"
                                                    tokenSeparators={[","]}
                                                    open={false}
                                                /> :
                                                    <div>
                                                        {displayData?.buyer_persons
                                                            ? displayData.buyer_persons.split(",").map((person, index) => (
                                                                <Tag key={index} color="blue" style={{ marginBottom: 4, marginRight: 4 }}>
                                                                    {person}
                                                                </Tag>
                                                            ))
                                                            : "Not Applicable"}
                                                    </div>
                                                }
                                            </Form.Item>
                                        </Col>
                                        {edit1 ? <Col span={3} style={{ marginTop: 5 }}>
                                            <Form.Item label=" ">
                                                <Button size="small" className="gradient-button" disabled={display} onClick={() => getTargetRolesData()}>
                                                    <AiIcon /> AI Assist
                                                </Button></Form.Item>
                                        </Col> : <></>}</Row>
                                </Col>
                                <Col span={24}>
                                    <Row align="middle" gutter={16} style={{ marginBottom: 30 }}>
                                        <Col span={edit1 ? 21 : 24} >
                                            <Form.Item label="Direct Competitors"
                                                name="directCompetitors"
                                                id="directCompetitors"
                                                rules={edit1 ? [{ required: true, whitespace: true, message: 'Please select a direct competitors', }] : [{ required: false }]}
                                            >
                                                {edit1 ?
                                                    <Select
                                                        mode="tags"
                                                        className='MultiUiNew'
                                                        style={{ width: "100%" }}
                                                        placeholder="Type and press enter"
                                                        tokenSeparators={[","]}
                                                    >
                                                        {accountbyType.filter((item) => item.account_type_name === "Competitor").map((option, i) => (
                                                            <Option value={option.account_name} key={i} >{option.account_name}</Option>))
                                                        }
                                                    </Select>
                                                    : <div>
                                                        {displayData?.direct_competitors
                                                            ? displayData.direct_competitors.split(",").map((person, index) => (
                                                                <Tag key={index} color="blue" style={{ marginBottom: 4, marginRight: 4 }}>
                                                                    {person}
                                                                </Tag>
                                                            ))
                                                            : "Not Applicable"}
                                                    </div>}
                                            </Form.Item>
                                        </Col>
                                        {edit1 ? <Col span={3} style={{ marginTop: 5 }}>
                                            <Form.Item label=" ">
                                                <Button size="small" className="gradient-button" disabled={display} onClick={() => getCompetitorsData()}>
                                                    <AiIcon /> AI Assist
                                                </Button></Form.Item>
                                        </Col> : <></>}</Row>
                                </Col>
                                <Col span={24} style={{ marginBottom: 30 }}>
                                    <Form.Item label="Key Features & Benefits" name="keyFeatures" id="keyFeatures" rules={edit1 ? [{ required: true, whitespace: true, message: 'Please enter a key features & benefits', }] : [{ required: false }]}
                                    >
                                        {edit1 ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter key features & benefits' /> :
                                            <span>{displayData?.key_features || "Not Applicable"}</span>
                                        }
                                    </Form.Item>
                                </Col>
                                <Col span={24} style={{ marginBottom: 30 }}>
                                    <Form.Item label="Competitive Advantages" name="competitiveAdvantages" id="competitiveAdvantages" rules={edit1 ? [{ whitespace: true, required: true, message: 'Please enter a competitive advantages', }] : [{ required: false }]}>
                                        {edit1 ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter competitive advantages' /> :
                                            <span>{displayData?.competitive_advantages || "Not Applicable"}</span>
                                        }
                                    </Form.Item>
                                </Col>
                                <Col span={24} style={{ marginBottom: 30 }}>
                                    <Form.Item label="Special Instructions for Bots" name="specialInstructionsforBots" id="specialInstructionsforBots" >
                                        {edit1 ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter special instructions for bots' /> :
                                            <span>{displayData?.special_instructionsfor_bots || "Not Applicable"}</span>
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </VerticalFormStyleWrap>
            </BasicFormWrapper>
        </div>
    </AddUser>)
    const onChange = async (key) => {
        // if (activeKey === "1") {
        //     const currentValues = form.getFieldsValue(true);
        //     const {
        //         serviceLineName,
        //         parentserviceLine,
        //         serviceLineOwner,
        //         description
        //     } = currentValues;
        //     if (action === "Specific_user") {
        //         const validation = RequiredValidity(group?.items);
        //         if (!validation.isValid) {
        //             message.warning("Please save or cancel your changes before switching tabs");
        //             return;
        //         }
        //     }
        //     let SaveQuery = "";
        //     let copiedGroup;
        //     if (action === "Specific_user") {
        //         copiedGroup = JSON.parse(JSON.stringify(group));
        //         const processedItems = await convertQueryData(copiedGroup.items, "Submit");
        //         copiedGroup.items = processedItems;
        //         const tableName = entityTableMap.find(t => t.entityName === "Users")?.tableName || "";
        //         const finalQuery = await buildQuery(tableName, copiedGroup);
        //         if (tableName) {
        //             SaveQuery = `SELECT {{*}} FROM ${tableName} WHERE (${finalQuery})`;
        //         } else {
        //             SaveQuery = finalQuery;
        //         }
        //     }
        //     const payload = {
        //         serviceLineName: normalizeValue(serviceLineName),
        //         serviceLineFiles: FILEList,
        //         parentServiceLine: normalizeValue(parentserviceLine === "Not Applicable" ? null : parentserviceLine),
        //         serviceLineOwner: normalizeValue(serviceLineOwner),
        //         description: normalizeValue(description),
        //         sharedWith: normalizeValue((profile.roleName === "Administrator" || (profile.companyRole === "Administrator" ||
        //             profile.companyRole === "CEO")) ? action : null),
        //         query: action === "Specific_user" ? copiedGroup : null,
        //         queryBuilder: action === "Specific_user" ? SaveQuery : null,
        //     }
        //     const updatedFields = getChangedFields(payload, leadInitial1);
        //     if (Object.keys(updatedFields).length !== 0) {
        //         message.warning("Please save or cancel your changes before switching tabs");
        //         return;
        //     }
        // }
        // if (edit1) {
        //     message.warning("Please save or cancel your changes before switching tabs");
        //     return;
        // }
        // setActiveKey(key);
        if (edit || edit1) {
            message.warning("Please save or cancel your changes before switching tabs");
            return;
        }
        setActiveKey(key);
    };
    return (
        <>
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={
                    typeOfAction === "Update" ?
                        <span>
                            Update Service Line
                            {displayData?.service_line_name && (
                                <>
                                    <span style={{
                                        margin: '0 10px',
                                        color: '#d9d9d9',
                                        fontWeight: 'normal'
                                    }}>|</span>
                                    <span style={{ fontWeight: 'normal' }}>
                                        {displayData.service_line_name}
                                    </span>
                                </>
                            )}
                        </span>
                        : "Add Service Line"
                }
                closable={false}
                placement="right"
                open={serviceLine}
                width="80%"
                extra={
                    < Space >
                        {(drawerFrom !== "Shared" && typePage !== "Details" && ((activeKey === "1" && !edit) || (activeKey !== "1" && !edit1))) ?
                            <div className='Hover-Refresh2 back-hover1 able-style'
                                role="button"
                                tabIndex={0} title='Edit'
                                onClick={() => activeKey === "1" ? setEdit(true) : setEdit1(true)}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        if (activeKey === "1") {
                                            setEdit(true)
                                        }
                                        else {
                                            setEdit1(true)
                                        }
                                    }
                                }}
                                aria-label='edit'
                            > <EditIcon height={20} width={20} /></div> : <></>}
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space >
                }
                footer={(uiReady && ((activeKey === "1" && edit) || (activeKey !== "1" && edit1))) ? [<div className="form_action_button">
                    <Button className="gray-button" onClick={() => PageCancel()} size="small" disabled={display} >
                        <FeatherIcon icon="x" />Cancel
                    </Button>
                    {(activeKey === "1" && typeOfAction === "Update") &&
                        <Button className="red-button" size="small" onClick={() => OnClickofDelete(serviceLineId)} disabled={display} >
                            <FeatherIcon icon="trash-2" />Delete
                        </Button>}
                    <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} loading={deleteClick} disabled={deleteClick || display}>
                        {!deleteClick && <FeatherIcon icon="save" />} {typeOfAction === "Update" ? "Update" : "Save"}
                    </Button>
                </div>] : false}
            >{(displayData && uiReady) ? <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                <Form
                    form={form} // single form for both tabs
                    layout="vertical"
                    onFinish={onSubmit} // send combined data to API
                    onFinishFailed={onFinishFailed}
                >
                    {(profile.roleName === "Administrator" && typeOfAction !== "Create") ? (
                        <div style={{ margin: "20px 40px" }}>
                            <Tabs
                                activeKey={activeKey}
                                items={[
                                    { key: '1', label: 'Generic Details', children: pageContent1 },
                                    { key: '2', label: 'Service Insights', children: pageContent2 },
                                ]}
                                onChange={onChange}
                                className='Settings-page-tab'
                            />
                        </div>
                    ) : (
                        <>{pageContent1}</>
                    )}
                </Form>
            </Scrollbars> :
                <div className="spin">
                    <Spin />
                </div>
                }
            </Drawer>
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="Service" getCallBack={getRefreshtheTable} />}
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
            {isModalVisible && <DeleteConnectionPopup confirmPopup={isModalVisible} setConfirmPopup={HandleIsModalVisible} Respone={errorData} page="Details" type="Service" getCallBack={getRefreshtheTable} />}
            {confirmPopup && <ConfirmationPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} GetCallback={deleteMenu} deleteId={deleteId} />}
        </>
    );
};

Popup.propTypes = {
    serviceLine: PropTypes.bool.isRequired,
    handleNavigation: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    // typeOfPage: PropTypes.string.isRequired,
    typeOfAction: PropTypes.string.isRequired,
    serviceLineId: PropTypes.number.isRequired,
    successMessage: PropTypes.func.isRequired,
    typePage: PropTypes.string,
    drawerFrom: PropTypes.string,
};

export default Popup;